import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { FormApi } from 'API/form'
import { IForm, Status } from 'interfaces'

const initialState: {
	list: IForm[]
	status: Status
} = {
	list: [],
	status: 'init',
}

export const getForms = createAsyncThunk('Form/getForms', async () => {
	const forms = await FormApi.getAll()
	return {
		forms,
	}
})
export const getForm = createAsyncThunk('Form/getForm', async (id: number) => {
	return await FormApi.getOne(id)
})

const FormSlice = createSlice({
	name: 'Form',
	initialState,
	reducers: {
		deleteItem(state, { payload }: PayloadAction<number>) {
			if (state.list) {
				const index = state.list.findIndex((f) => f.id === payload)
				if (index >= 0) {
					state.list.splice(index, 1)
				}
			}
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getForms.pending, (state) => {
			state.status = 'pending'
		})
		builder.addCase(getForms.rejected, (state) => {
			state.status = 'rejected'
		})
		builder.addCase(getForms.fulfilled, (state, { payload }) => {
			if (payload) {
				state.list = payload.forms
			}
			state.status = 'fulfilled'
		})
		builder.addCase(getForm.fulfilled, (state, { payload }) => {
			if (!payload) return
			const index = state.list.findIndex((f) => f.id === payload.id)
			if (index >= 0) {
				state.list.splice(index, 1, payload)
			} else {
				state.list.push(payload)
			}
		})
	},
})

export const FormAction = FormSlice.actions

export const FormReducer = FormSlice.reducer
